import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-npv-base',
  templateUrl: './npv-base.component.html',
  styleUrls: ['./npv-base.component.scss']
})
export class NpvBaseComponent implements OnInit {


  constructor() {
  }

  ngOnInit(): void {
  }
}
